import DetailNavTitle from './detail-nav-title';

export default DetailNavTitle;
